<template>
    <div class="tw-menu">
        <Menubar :model="mainMenus">
            <template #start>
                <img :src="logo" height="40" class="p-mr-2" id="logo" @click="onHome" :onerror="onImgError" style="cursor: pointer;margin: 5px;" alt="" />
            </template>
            <template #end>
                <button class="p-link tw-menu-topbar-button" style="margin-right: 10px;"  @click="toggle" aria-haspopup="true" aria-controls="overlay_menu">
                    <img src="../../assets/img/head_boy.png" alt="">
				</button>
                <Menu id="overlay_menu" ref="overlay_menu" :model="persons" :popup="true" />
            </template>
        </Menubar>
        <tw-row style="height: calc(100vh - 67px)">
            <tw-col :xs_span="12" :sm_span="3" :md_span="3" :lg_span="2" :xl_span="2" class="tw-menu-main tw-menu-main-left">
                <PanelMenu :model="activeSubmenus" />
            </tw-col>

            <tw-col :xs_span="12" :sm_span="9" :md_span="9" :lg_span="10" :xl_span="10" class="tw-menu-main">
                <tw-router-view>

                </tw-router-view>
            </tw-col>
        </tw-row>
    </div>
</template>

<script>
import { computed, ref, onMounted } from 'vue'
import Menubar from 'primevue/menubar';
import PanelMenu from 'primevue/panelmenu';
import serviceProvider from "../../services/service-provider"
import messageService from '../../services/message.service'
import Menu from 'primevue/menu';

export default {
    name: 'tw-menu',
    components: {
        Menubar,
        PanelMenu,
        Menu
    },
    setup() {
        const menus = ref([])     // 顶栏：第一级

        // 顶部导航菜单
        const mainMenus = computed(() => {
            return menus.value?.map(el => {
                return {
                    label: el.label,
                    file_name: el.file_name,
                    icon: 'pi pi-folder',
                    visible: el.visible,
                    children: el.children,
                    command: (event) => {
                        // event.originalEvent: Browser event
                        // event.item: Menuitem instance
                        // console.log('mainMenus: ', event)
                        deel(event.item?.children)
                    }
                }
            })
        })

        // 左侧菜单栏
        const activeSubmenus = ref([])

        const deel = (items) => {
            const menu = [];

            items.forEach(el => {
                menu.push({
                    label: el.label,
                    file_name: el.file_name,
                    icon: el.icon,
                    visible: el.visible,
                    items: el.children,
                    type: el.type,
                    command: (event) => {
                        subMenuSelect(event.item)
                    }
                })
            })

            activeSubmenus.value = menu
        }

        // 子菜单选择时渲染组件
        const subMenuSelect = function(menu) {
            switch (menu.type) {
                case 'page':
                    if (menu?.file_name) {
                        serviceProvider.windowService.openPage(menu.file_name)
                    } else {
                        messageService.info({
                            showClose: true,
                            message: '此项未配置页面！'
                        })
                    }
                    break;
                case 'link':
                    if (menu?.url) {
                        window.open(menu.url)
                    } else {
                        messageService.info({
                            showClose: true,
                            message: '此项未配置外链地址！'
                        })
                    }
                    break;
                default:
                    messageService.info({
                        showClose: true,
                        message: `不可识别的页面类型 ${menu.type}！`
                    })
                    break;
            }
        }

        const onHome = function() {
            serviceProvider.windowService.goHome();
        }

        const logo = ref(`${process.env.BASE_URL}img/${serviceProvider?.userService?.user.sob_no}.png`)

        const onImgError = function(event) {
            const img = event.srcElement
            img.onerror = null
            img.src = `${process.env.BASE_URL}img/logo.png`
        }

        const overlay_menu = ref();
        const toggle = () => {
            overlay_menu.value.toggle(event);
        }

        const userType = serviceProvider?.userService?.user?.user_type ?? 'user';
        
        const sobList = ref([])

        const persons = ref([])

        const onMenuSelect = function(key, menu) {
            switch (key) {
                case 'sobs': // 账套管理
                    serviceProvider.windowService.openPage('sobs')
                    break;
                case 'user': // 用户权限
                    serviceProvider.windowService.openPage('user')
                    break;
                case 'profile': // 个人信息
                    serviceProvider.windowService.openPage('profile')
                    break;
                case 'logout': // 注销
                    messageService.confirm(`确定要注销当前登录用户吗？`).then(() => {
                        serviceProvider?.userService.logout()
                        serviceProvider?.windowService.openPage('login')
                    }).catch(() => {

                    })
                    break;
                case 'exit': // 用户退出
                    if (window.api) {
                        // ApiCloud 关闭应用
                        window.api?.closeWidget();
                    } else {
                        // 关闭浏览器
                        messageService.confirm(`确定要退出程序吗？`).then(() => {
                            open(location, '_self').close();
                        }).catch(() => {

                        })
                    }
                    break;
                default:
                    if (key.indexOf('sob_no:') !== -1) {
                        const sobNo = key.slice(7)
                        // 账套不相同时才进行切换
                        if (serviceProvider?.userService.user.sob_no !== sobNo) {
                            const sob = sobList.value.find(el => el.sob_no === sobNo)
                            messageService.confirm(`确定要切换到【${sob.sob_name}】账套吗？`).then(() => {
                                // 不使用路由跳转是因为路由跳转时不触发 beforeunload 事件，虽然可以手动在这里调用相关函数（例如保存个人配置等），
                                // 但使用 window.location.href 进行跳转可以使用正常的流程，且切换账套更为干净（刷新了浏览器）
                                // router.push({ name: 'login-passport', query: { token: serviceProvider?.userService.user.token, sob_no: sobNo } })
                                window.location.href = `${window.location.origin}${process.env.BASE_URL}login-passport?token=${serviceProvider?.userService.user.token}&sob_no=${sobNo}`
                            }).catch(() => {

                            })
                        }
                    } else {
                        // 第一层是固定的更多菜单项，需要去除
                        switch (menu.type) {
                            case 'page':
                                if (menu?.file_name) {
                                    serviceProvider.windowService.openPage(menu.file_name)
                                } else {
                                    messageService.info('此项未配置页面！')
                                }
                                break;
                            case 'link':
                                if (menu?.url) {
                                    window.open(menu.url)
                                } else {
                                    messageService.info('此项未配置外链地址！')
                                }
                                break;
                            default:
                                messageService.info(`不可识别的页面类型 ${key.type}！`)
                                break;
                        }
                    }
                    break;
            }
        }

        onMounted(() => {
            if(!serviceProvider.systemService) {
                console.error('未提供systemService服务，无法获取路由配置')
            }else{
                menus.value = serviceProvider?.systemService?.menus
                if (menus.value.length) {
                    deel(menus.value[0]?.children)
                }
            }
            
            if(!serviceProvider.userService){
                console.error('未提供userService服务，无法获取用户信息')
            }else{
                if(userType === 'root') {
                    persons.value.push({
                        label:'账套管理',
                        icon:'pi pi-bars',
                        command: () => {
                            onMenuSelect('sobs')
                        }
                    })
                }
                if(userType === 'root' || userType === 'admin') {
                    persons.value.push({
                        label:'用户权限',
                        icon:'pi pi-bookmark',
                        command: () => {
                            onMenuSelect('user')
                        }
                    })
                }
                persons.value.push({
                    label:'个人信息',
                    icon:'pi pi-id-card',
                    command: () => {
                        onMenuSelect('profile')
                    }
                })
            }

            if(!serviceProvider.httpService) {
                console.error('未提供httpService服务，无法请求账套列表')
            }else{
                serviceProvider?.httpService.get('sob-list', { app_no: serviceProvider?.systemService.project_id }).then(result => {
                    if(result?.length > 1){
                        sobList.value = result.map(el => {
                            return {
                                label: el.sob_name,
                                icon: el.sob_no === serviceProvider?.userService.user.sob_no ? 'pi pi-angle-right' : '',
                                sob_no: el.sob_no,
                                sob_name: el.sob_name,
                                command: (event) => {
                                    onMenuSelect(`sob_no:${el.sob_no}`, event.item)
                                }
                            }
                        })
                        persons.value.push({
                            label: '账套',
                            items: sobList.value
                        })
                    }
                    if(userType === 'root' || userType === 'admin') {
                        persons.value.push({
                            label:'注销',
                            icon:'pi pi-sign-out',
                            command: () => {
                                onMenuSelect('logout')
                            }
                        })
                    }
                    persons.value.push({
                        label:'退出',
                        icon:'pi pi-power-off',
                        command: () => {
                            onMenuSelect('exit')
                        }
                    })
                })
            }
        })

        return {
            mainMenus,
            activeSubmenus,
            logo,
            onHome,
            onImgError,
            persons,
            overlay_menu,
            toggle
        }
    }
}

</script>